import * as React from "react"
import { Link, graphql, StaticQuery } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"

function SpeakerCredit({ speakers }) {
  const SPEAKER_CREDIT = graphql`
    query {
      allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "speaker" } } }
        sort: { fields: frontmatter___slug, order: ASC }
      ) {
        nodes {
          frontmatter {
            title
            slug
            featuredImage {
              childImageSharp {
                gatsbyImageData(
                  formats: WEBP
                  height: 230
                  width: 230
                  quality: 70
                  placeholder: BLURRED
                  transformOptions: { cropFocus: CENTER, fit: COVER }
                )
              }
            }
          }
        }
      }
    }
  `
  return (
    <StaticQuery
      query={SPEAKER_CREDIT}
      render={({ allMarkdownRemark: { nodes: allSpeakers } }) => {
        return allSpeakers
          .filter(speaker => speakers.includes(speaker.frontmatter.slug))
          .map(speaker => {
            const hasImage = speaker.frontmatter.featuredImage?.childImageSharp?.gatsbyImageData
            
            return (
              <div className="presenter-grid">
              <div key={speaker.frontmatter.slug} className="presenter mt-3">
                <AnchorLink to={"/speakers#" + speaker.frontmatter.slug}>
                  {hasImage ? (
                    <GatsbyImage
                      image={speaker.frontmatter.featuredImage.childImageSharp.gatsbyImageData}
                      alt={speaker.frontmatter.title}
                      className="mr-3"
                      loading="lazy"
                    />
                  ) : (
                    <StaticImage
                      src="../images/CSICON-logo-standard.png"
                      alt="CSICon Logo"
                      className="mr-3"
                      width={230}
                      height={230}
                      placeholder="blurred"
                    />
                  )}
                </AnchorLink>
                <div className="presenter-info">
                  <AnchorLink to={"/speakers#" + speaker.frontmatter.slug}>
                    <h5>{speaker.frontmatter.title}</h5>
                  </AnchorLink>
                </div>
              </div>
              </div>
            )
          })
      }}
    />
  )
}

export default SpeakerCredit